import Api from "./api";
import OidcManager from "./oidcManager";

export interface TaxRates {
    material: number,
    labor: number,
    equipment: number,
    totalOnly: number,
    contract: number
}

export enum TaxType {
    material,
    labor,
    equipment,
    totalOnly,
    contract
}

export class TaxRatesApi extends Api {

    public constructor(oidc: OidcManager, address: string) {
        super(oidc, address)
    }

    load(command: {estimateId: number }): JQueryPromise<TaxRates> {
        return super.get("/api/tax-rates", command);
    }

    save(command: TaxRates & { estimateId: number }): JQueryPromise<TaxRates> {
        return super.post("/api/tax-rates", command);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/api/tax-rates.ts